module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"SkillStation","short_name":"SkillStation","start_url":"/","background_color":"#030712","theme_color":"#030712","display":"minimal-ui","icon":"src/images/512x512.png","description":"Пронајдете спортски клубови, школи и курсеви за деца и возрасни со SkillStation – најголемата платформа за активности по град и категорија. Откријте програми што поддржуваат спорт, образование и личен развој","lang":"mk","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"a47a982d1ae261f6b03c7e6aeec8721c"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
